<template>
  <div>
    <div class="row">
      <div class="col-8">
        <simple-table title="Organizations"
                      url="/entity/organizations"
                      :columns="tableColumns"
                      :actions="actions"
                      :is-entity="true"
                      @clearScreen="closeViewPanel()"></simple-table>
      </div>
      <div class="col-4" v-if="hasOrganizations">
        <card>
          <template slot="header">
            <h4 class="card-title">
              Organization info:
              <button class="btn btn-danger pull-right" @click="closeViewPanel">
                Close
              </button>
              <button class="btn btn-success pull-right" @click="saveData" v-if="editMode">
                Save
              </button>
            </h4>
          </template>
          <fg-input label="Organization Name"
                    type="text"
                    v-model="organization.name"
                    :disabled="true"
                    placeholder="Package Name">
          </fg-input>
          <fg-input label="Organization Slug"
                    type="text"
                    v-model="organization.slug"
                    :disabled="true"
                    placeholder="Package Name">
          </fg-input>
          <fg-input label="Publisher"
                    type="text"
                    :value="`${organization.Owner.fullName} (${organization.Owner.username})`"
                    :disabled="true"
                    placeholder="Publisher">
          </fg-input>
          <div class="form-group" v-if="editMode">
            <label>Organization Type</label>
            <select class="form-control"
                      v-model="organization.type"
                      placeholder="Organization Type">
              <option value="FREE">Free</option>
              <option value="PUBLIC">Public</option>
              <option value="PRIVATE">Private</option>
            </select>
          </div>
          <fg-input label="Organization Type"
                    type="text"
                    :value="`${organization.translatedType}`"
                    :disabled="true"
                    v-if="!editMode"
                    placeholder="Organization Type">
          </fg-input>
          <fg-input label="Initial Creation Date"
                    type="text"
                    :value="parseDate(organization.createdAt)"
                    :disabled="true"
                    placeholder="Initial Publish Date">
          </fg-input>
          <fg-input label="Last Update"
                    type="text"
                    :value="parseDate(organization.updatedAt)"
                    :disabled="true"
                    placeholder="Last Update">
          </fg-input>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import SimpleTable from "../../../components/Beast/Table/SimpleTable.vue";

export default {
  components: {
    SimpleTable,
  },
  computed: {
    hasOrganizations() {
      return Object.keys(this.organization).length > 0;
    }
  },
  data() {
    return {
      organization: {},
      editMode: false,
      tableColumns: [
        {
          label: "Slug",
          minWidth: 100,
          field: "slug"
        },
        {
          label: "Type",
          minWidth: 50,
          field: "translatedType"
        },
        {
          label: "Owner",
          minWidth: 50,
          field: "Owner.username",
          template: value => `<a href='/users/management/${value}' class="text-success">${value}</a>`
        },
        {
          label: "Last Update",
          minWidth: 50,
          field: "updatedAt",
          template: value => moment(value).format("DD.MM.YYYY HH:mm:ss")
        }
      ],
      actions: [
        {
          label: "View",
          icon: "search",
          class: "btn-link text-info",
          action: (item) => {
            this.organization = item;
            this.editMode = false;
          }
        },
        {
          label: "Edit",
          icon: "edit",
          class: "btn-link text-warning",
          check: item => !item.isSync,
          action: (item) => {
            this.organization = item;
            this.editMode = !item.isSync;
          }
        },
        {
          label: "Delete",
          icon: "times",
          class: "btn-link text-danger",
          key: "id",
          value: "name",
          delete: true,
          check: item => !item.isSync
        }
      ]
    };
  },
  methods: {
    closeViewPanel() {
      this.organization = {};
      this.editMode = false;
    },

    async saveData() {
      try {
        await this.axios.put(`/entity/organizations/${this.organization.id}`, {
          organization: this.organization
        });
        this.$notify({
          message: "Data saved"
        });
        this.closeViewPanel();
      } catch (e) {
        this.$notify({
          type: "danger",
          message: e.response.data.message || e.message
        });
      }
    },

    parseDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm:ss");
    }
  }
};
</script>
<style scoped>
</style>
